import React, { useRef, useState } from 'react';
import cx from 'classnames';
import styles from './UserItem.module.scss';
import Icon from '../../Icon/Icon';
import { useTranslation } from 'react-i18next';
import { useIsOverflow } from '../../../hooks/useIsOverflow';
import Tooltip from '../../Tooltip/Tooltip';

const UserItem = ({ user, existingUser, newUser, currentUser, index, handleDelete, children, className }) => {
  const nameRef = useRef(null);
  const { t } = useTranslation();
  const { isOverflow } = useIsOverflow(nameRef);
  const [isHover, setIsHover] = useState(false);

  const toggleMouseEnterTitle = () => {
    setIsHover(true);
  };

  const toggleMouseLeaveTitle = () => {
    setIsHover(false);
  };

  return (
    <div key={index} className={cx(styles.userContainer, { [styles.firstUserContainer]: !index }, className)} >
      <div className={styles.userInfo}>
        <div className={styles.photoPlaceholder}>
          {existingUser && !user?.avatar && user?.name[0]?.toUpperCase()}
          {existingUser && user?.avatar && <img src={user?.avatar} className={styles.avatar} alt={t('clip_organizer.add_modal.avatar')} />}
          {newUser && user?.email[0].toUpperCase()}
        </div>
        <span
          className={styles.email}
          onMouseEnter={() => toggleMouseEnterTitle(index)}
          onMouseLeave={() => toggleMouseLeaveTitle(index)}
          ref={nameRef}
        >
          {user?.name ?? user?.email}
        </span>
        {existingUser && currentUser.username === user.username && <span>({t('share_folder_modal.first_step.you')})</span>}
        {existingUser && handleDelete && <Icon src="close" className={styles.deleteIcon} onClick={() => handleDelete(user?.username)} />}
        {newUser && handleDelete && <Icon src="close" className={styles.deleteIcon} onClick={() => handleDelete(user?.email)} />}
      </div>
      {children}
      <Tooltip text={user.email} isHover={isHover} />
    </div>
  );
};

export default UserItem;
